import { render } from "./Triggers.vue?vue&type=template&id=5fd978b4&scoped=true&ts=true"
import script from "./Triggers.vue?vue&type=script&lang=ts"
export * from "./Triggers.vue?vue&type=script&lang=ts"

import "./Triggers.vue?vue&type=style&index=0&id=5fd978b4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd978b4"]])

export default __exports__